import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { DEFAULT_CONTENT, mergeDeep } from "@/lib/siteContent";

const CACHE_KEY = "site_content_v1";

const ContentContext = createContext({ content: DEFAULT_CONTENT, refresh: () => {} });

export const ContentProvider = ({ children }) => {
  const [stored, setStored] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(CACHE_KEY)) || {};
    } catch {
      return {};
    }
  });
  const [ready, setReady] = useState(false);

  const refresh = () =>
    api
      .get("/content")
      .then((res) => {
        setStored(res.data || {});
        localStorage.setItem(CACHE_KEY, JSON.stringify(res.data || {}));
      })
      .catch(() => {})
      .finally(() => setReady(true));

  useEffect(() => {
    refresh();
  }, []);

  const content = useMemo(() => mergeDeep(DEFAULT_CONTENT, stored), [stored]);

  useEffect(() => {
    if (content?.seo?.title) document.title = content.seo.title;
  }, [content?.seo?.title]);

  return (
    <ContentContext.Provider value={{ content, refresh, ready }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
